import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProject, IDataInput } from '../../../interface/interfaces';

interface IInitialState {
    projectsLoading: boolean;
    projectsData: IProject[];
    projectError: string;
}

const initialState: IInitialState = {
    projectsLoading: false,
    projectsData: [],
    projectError: '',
};

const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchProjectDataPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.projectsLoading = true;
            state.projectError = '';
        },

        fetchProjectDataFulfilled: (state: IInitialState, action: PayloadAction<IProject[]>) => {
            state.projectsLoading = false;
            state.projectsData = action.payload;
            state.projectError = '';
        },

        fetchProjectDataFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.projectsLoading = false;
            state.projectsData = [];
            state.projectError = action.payload;
        },
    },
});

export default projectSlice.reducer;
export const { fetchProjectDataPending, fetchProjectDataFulfilled, fetchProjectDataFailure } = projectSlice.actions;
